import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "title-big t-blue uppercase text-center mb-5" }
const _hoisted_2 = { class: "private-policy_section pb-5 mb-5" }
const _hoisted_3 = { class: "private-policy_aside pt-1" }
const _hoisted_4 = {
  href: "#1",
  class: "text-motserrat-16 pointer private-policy_link text-decoration-none pl-2 t-dark active"
}
const _hoisted_5 = {
  href: "#2",
  class: "text-motserrat-16 pointer private-policy_link text-decoration-none pl-2 t-dark"
}
const _hoisted_6 = {
  href: "#3",
  class: "text-motserrat-16 pointer private-policy_link text-decoration-none pl-2 t-dark"
}
const _hoisted_7 = {
  href: "#4",
  class: "text-motserrat-16 pointer private-policy_link text-decoration-none pl-2 t-dark"
}
const _hoisted_8 = {
  href: "#5",
  class: "text-motserrat-16 pointer private-policy_link text-decoration-none pl-2 t-dark"
}
const _hoisted_9 = {
  href: "#6",
  class: "text-motserrat-16 pointer private-policy_link text-decoration-none pl-2 t-dark"
}
const _hoisted_10 = {
  href: "#7",
  class: "text-motserrat-16 pointer private-policy_link text-decoration-none pl-2 t-dark"
}
const _hoisted_11 = {
  href: "#8",
  class: "text-motserrat-16 pointer private-policy_link text-decoration-none pl-2 t-dark"
}
const _hoisted_12 = { class: "private-policy_article" }
const _hoisted_13 = {
  class: "mb-2",
  id: "1"
}
const _hoisted_14 = { class: "title-big monserrat big t-blue uppercase text-start" }
const _hoisted_15 = { class: "text-motserrat-16 mt-2" }
const _hoisted_16 = {
  class: "mb-2",
  id: "2"
}
const _hoisted_17 = { class: "title-big monserrat big t-blue uppercase text-start" }
const _hoisted_18 = { class: "text-motserrat-16 mt-2" }
const _hoisted_19 = {
  class: "mb-2",
  id: "3"
}
const _hoisted_20 = { class: "mb-2" }
const _hoisted_21 = { class: "title-big monserrat big t-blue uppercase text-start" }
const _hoisted_22 = { class: "mb-2" }
const _hoisted_23 = { class: "title-big monserrat small t-blue uppercase text-start" }
const _hoisted_24 = { class: "text-motserrat-16 mt-2" }
const _hoisted_25 = { class: "mb-2" }
const _hoisted_26 = { class: "title-big monserrat small t-blue uppercase text-start" }
const _hoisted_27 = { class: "text-motserrat-16 mt-2" }
const _hoisted_28 = { class: "mb-2" }
const _hoisted_29 = { class: "title-big monserrat small t-blue uppercase text-start" }
const _hoisted_30 = { class: "text-motserrat-16 mt-2" }
const _hoisted_31 = { class: "mb-2" }
const _hoisted_32 = { class: "title-big monserrat small t-blue uppercase text-start" }
const _hoisted_33 = { class: "text-motserrat-16 mt-2" }
const _hoisted_34 = {
  class: "mb-2",
  id: "4"
}
const _hoisted_35 = { class: "title-big monserrat big t-blue uppercase text-start" }
const _hoisted_36 = { class: "text-motserrat-16 mt-2" }
const _hoisted_37 = {
  class: "mb-2",
  id: "5"
}
const _hoisted_38 = { class: "title-big monserrat big t-blue uppercase text-start" }
const _hoisted_39 = { class: "text-motserrat-16 mt-2" }
const _hoisted_40 = {
  class: "mb-2",
  id: "6"
}
const _hoisted_41 = { class: "title-big monserrat big t-blue uppercase text-start" }
const _hoisted_42 = { class: "text-motserrat-16 mt-2" }
const _hoisted_43 = {
  class: "mb-2",
  id: "7"
}
const _hoisted_44 = { class: "title-big monserrat big t-blue uppercase text-start" }
const _hoisted_45 = { class: "text-motserrat-16 mt-2" }
const _hoisted_46 = {
  class: "mb-2",
  id: "8"
}
const _hoisted_47 = { class: "title-big monserrat big t-blue uppercase text-start" }
const _hoisted_48 = { class: "text-motserrat-16 mt-2" }

import { onMounted, onUnmounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PrivatePolicyView',
  setup(__props) {

const observerHandler = (entries: IntersectionObserverEntry[]) => {
  entries.forEach((entry) => {
    const id = entry.target.id;
    if (entry.intersectionRatio > 0) {
      (document.querySelector(`a[href="#${id}"]`) as Element).classList.add(
        "active"
      );
    } else {
      (document.querySelector(`a[href="#${id}"]`) as Element).classList.remove(
        "active"
      );
    }
  });
};

const observer = new IntersectionObserver(observerHandler);

onMounted(() => {
  document.querySelectorAll("section[id]").forEach((section) => {
    observer.observe(section);
  });
});

onUnmounted(() => {
  observer.disconnect();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$tc("Privacy Policy")), 1),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("aside", _hoisted_3, [
        _createElementVNode("a", _hoisted_4, _toDisplayString(_ctx.$tc("Introduction")), 1),
        _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.$tc("Definitions")), 1),
        _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.$tc("Data Protection and Personal Data Processing")), 1),
        _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.$tc("Processing outside the EU / EEA")), 1),
        _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.$tc("Auditing")), 1),
        _createElementVNode("a", _hoisted_9, _toDisplayString(_ctx.$tc("Data security")), 1),
        _createElementVNode("a", _hoisted_10, _toDisplayString(_ctx.$tc("Notification of a data security breach")), 1),
        _createElementVNode("a", _hoisted_11, _toDisplayString(_ctx.$tc("Other conditions")), 1)
      ]),
      _createElementVNode("article", _hoisted_12, [
        _createElementVNode("section", _hoisted_13, [
          _createElementVNode("p", _hoisted_14, _toDisplayString("1. " + _ctx.$tc("Introduction")), 1),
          _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$tc("text_1")), 1)
        ]),
        _createElementVNode("section", _hoisted_16, [
          _createElementVNode("p", _hoisted_17, _toDisplayString("2. " + _ctx.$tc("Definitions")), 1),
          _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$tc("text_2")), 1)
        ]),
        _createElementVNode("section", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("p", _hoisted_21, _toDisplayString("3. " + _ctx.$tc("Data Protection and Personal Data Processing")), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("p", _hoisted_23, _toDisplayString("3.1. " +
                _ctx.$tc("Responsibilities of the Service Provider and the Customer")), 1),
              _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$tc("text_3")), 1)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("p", _hoisted_26, _toDisplayString("3.2. " + _ctx.$tc("Data deletion/restoration")), 1),
              _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$tc("text_4")), 1)
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("p", _hoisted_29, _toDisplayString("3.3. " + _ctx.$tc("Subcontractors")), 1),
              _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$tc("text_5")), 1)
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("p", _hoisted_32, _toDisplayString("3.4. " + _ctx.$tc("The service provider's obligation to assist")), 1),
              _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.$tc("text_6")), 1)
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_34, [
          _createElementVNode("p", _hoisted_35, _toDisplayString("4. " + _ctx.$tc("Processing outside the EU / EEA")), 1),
          _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.$tc("text_7")), 1)
        ]),
        _createElementVNode("section", _hoisted_37, [
          _createElementVNode("p", _hoisted_38, _toDisplayString("5. " + _ctx.$tc("Auditing")), 1),
          _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.$tc("text_8")), 1)
        ]),
        _createElementVNode("section", _hoisted_40, [
          _createElementVNode("p", _hoisted_41, _toDisplayString("6. " + _ctx.$tc("Data security")), 1),
          _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.$tc("text_9")), 1)
        ]),
        _createElementVNode("section", _hoisted_43, [
          _createElementVNode("p", _hoisted_44, _toDisplayString("7. " + _ctx.$tc("Notification of a data security breach")), 1),
          _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.$tc("text_10")), 1)
        ]),
        _createElementVNode("section", _hoisted_46, [
          _createElementVNode("p", _hoisted_47, _toDisplayString("8. " + _ctx.$tc("Other conditions")), 1),
          _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.$tc("text_11")), 1)
        ])
      ])
    ])
  ], 64))
}
}

})